// Custom Cart Drawer: Show Cardstock Finish & Custom Text 1 in Studio theme
document.addEventListener('DOMContentLoaded', function() {

  function renderCartProperties() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        cart.items.forEach(item => {
          // Find cart drawer item by data-key
          const itemEl = document.querySelector(`.cart-item[data-key="${item.key}"]`);
          if (!itemEl) return;

          // Remove old properties if already added
          const oldProps = itemEl.querySelector('.cart-properties');
          if (oldProps) oldProps.remove();

          // Create new list
          const ul = document.createElement('ul');
          ul.classList.add('cart-properties');

          // Only show these two fields
          ['Cardstock Finish', 'Custom Text 1'].forEach(propName => {
            if(item.properties[propName] && item.properties[propName] !== "") {
              const li = document.createElement('li');
              li.innerHTML = `<strong>${propName}:</strong> ${item.properties[propName]}`;
              ul.appendChild(li);
            }
          });

          // Append under product title
          const titleEl = itemEl.querySelector('.cart-item__title') || itemEl.querySelector('.cart-item__content');
          if(titleEl) titleEl.appendChild(ul);
        });
      });
  }

  // Run on page load
  renderCartProperties();

  // Re-run whenever the cart updates (Studio triggers 'cart:updated')
  document.addEventListener('cart:updated', renderCartProperties);
});
